import { render, staticRenderFns } from "./HomeAffiliate.vue?vue&type=template&id=319c29f2"
import script from "./HomeAffiliate.vue?vue&type=script&lang=js"
export * from "./HomeAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports